var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12 float-left"},[_c('SentimentTrend',{attrs:{"title":"","subText":"","modal":"20","zoom_start":"70"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }